<script lang="ts">
    import { Button, Col, Container } from "sveltestrap";
    import * as SvgIcon from "../../../../Data/ErrorPage/ErrorPageSvg";
    import { ErrorMassge, Errorbtn, Error2 } from "../../../../utils/Constant/Constant";
</script>
<div class="page-wrapper" id="pageWrapper">        
  <div class="error-wrapper">
    <Container>
      <div class="error-page1">
        <div class="svg-wrraper mb-0">
          {@html SvgIcon["error2"]}
        </div>
        <Col md={{ size: 8, offset: 2 }}>
          <h3>{Error2}</h3>
          <p class="sub-content">{ErrorMassge}</p>
          <Button color="primary" size="lg" href="/dashboard/default">{Errorbtn}</Button>
        </Col>
      </div>
    </Container>
  </div>
</div>